import React, {Component} from "react";

class Form extends Component{

    constructor(props){
        super(props);
        
        this.initialState = {
            name: "",
            role: ""
        };

        this.state = this.initialState;
    }

    handleChange = event => {
      const { name, value } = event.target;

      this.setState({
          [name]: value
      });
    };

    onFormSubmit = event => {
        event.preventDefault();

        this.props.handleSubmit(this.state);
        this.setState(this.initialState);
    }

    render(){
      const { name, role } = this.state;

      return(
        <form>
            <label>Name</label>
            <input type="text"
                   name="name"
                   value={name}
                   onChange={this.handleChange}
            />     
            <label>Role</label>  
            <input type="text"
                   name="role"
                   value={role}                   
                   onChange={this.handleChange}
            />   
            <button type="submit" onClick={this.onFormSubmit}>
              Submit
            </button>  
        </form>
      );
    }

}

export default Form;